import endpoints from "static/endpoints";
import api from "app/lib/api";

export const updateMFAStatus = async () => {
  const response = await api.put(endpoints.mfa.updateStatus);
  return response;
};

export const validateOTPForEnable = async (payload) => {
  const response = await api.post(endpoints.mfa.validateEnableOTP, payload);
  return response;
};

export const validateLoginOTP = async (payload) => {
  const response = await api.post(endpoints.mfa.validateLoginOTP, payload);
  return response;
};

export const requestOTP = async (payload = {}) => {
  const response = await api.put(endpoints.mfa.requestOTP, payload);
  return response;
};

export const getMFAStatus = async () => {
  const response = await api.get(endpoints.mfa.getMFAStatus);
  return response;
};
